export default "__VITE_ASSET__DRlah674__"